import { render, staticRenderFns } from "./TitleParagraph.vue?vue&type=template&id=1fd2e88d&scoped=true&"
import script from "./TitleParagraph.vue?vue&type=script&lang=js&"
export * from "./TitleParagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2e88d",
  null
  
)

export default component.exports